export const SLICE_NAME = 'lunaStreamsQueue';
